var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{staticClass:"subscription-expiry",attrs:{"color":"#C8E4D6","value":_vm.percentage,"height":"8","rounded":""}})}
var staticRenderFns = []

export { render, staticRenderFns }